import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { LoginService } from './login.service';

@Component({
  selector: 'app-login-page',
  template: `
    <app-login
      [validator]="service"
      [signUpPath]="signUpPath"
      [username]="username"
      usernameInputLabel="Usuário"
    ></app-login>
  `
})
export class LoginPageComponent implements OnInit {
  readonly signUpPath = '/signup';

  username: string;

  constructor(public service: LoginService, private route: ActivatedRoute) {
    this.route.queryParams.subscribe(params => {
      this.username = params['username'];
    });
  }

  ngOnInit() {}
}
